import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { RequiredSelectValidator } from '../../validator/required-select/required-select.validator';
import { NumericalValidator } from '../../validator/numerical/numerical.validator';
import { AlphaNumericalValidator } from '../../validator/alphanumeric/alpha-numeric.validator';
import { MobilePhoneNumberValidator } from '../../validator/mobilephonenumber/mobilephonenumber.validators';
import { AlphabetValidator } from '../../validator/alphabet/alphabet.validator';

import { NoSpaceValidator } from '../../validator/no-space/no-space.validator';
import { NoNumericValidator } from '../../validator/no-numeric/no-numeric.validator';
import { NoDashValidator } from '../../validator/no-dash/no-dash.validator';
import { numberDelimiter } from '../../utils/input-handler/number-delimiter';
import { formGroupDefaultValue } from '../../utils/form-group/form-group-default-value';
export class TransformObjectFormService {
constructor() {}
/**
 * @param {?} loanData
 * @return {?}
 */
public sliderAuthModel(loanData: any) {
    if (loanData.maritalStatusType !== 'Married') {
      delete loanData.spouse;
    }

    if (loanData.spouse && !loanData.spouse.name) {
      delete loanData.spouse;
    }

    if (
      loanData.income.jobType === 'Student' ||
      loanData.income.jobType === 'Unemployed'
    ) {
      delete loanData.income;
    }

    // delete unneeded object keys data
    delete loanData.documentValidDate;
    delete loanData.documents;
    delete loanData.facebookToken;
    delete loanData.media;
    delete loanData.jdOrderId;
    delete loanData.pageTrack;
    delete loanData.customerIP;
    delete loanData.code;
    delete loanData.pMarketing;
    delete loanData.vehicles;
    delete loanData.tMarketing;
    delete loanData.partnerPhone;
    delete loanData.sessionId;
    delete loanData.otherLoans;
    delete loanData.insuranceMarketingConsent;
    delete loanData.insurance;
    delete loanData.heardFrom;
    delete loanData.guarantor;
    delete loanData.contractStatus;
    delete loanData.company;
    delete loanData.browserName;
    delete loanData.additionalParameters;
    delete loanData.additionalInfo;
    delete loanData.account;
    delete loanData.aasaAsBeneficiaryConsent;
    delete loanData.mothersPhone;
    delete loanData.firstPaymentDate;
    delete loanData.familyCardNumber;

    return loanData;
  }
/**
 * @param {?} sliderData
 * @param {?} obj
 * @param {?} type
 * @return {?}
 */
public formModel(sliderData: any, obj: any, type: string) {
    const /** @type {?} */ group: any = {
      loanAmount: [
        sliderData.loanAmount ? sliderData.loanAmount : null,
        [Validators.required],
      ],
      loanPeriod: [
        sliderData.loanPeriod ? sliderData.loanPeriod : null,
        [Validators.required],
      ],
      loanPurpose: [
        sliderData.loanPurpose ? sliderData.loanPurpose : '0',
        [RequiredSelectValidator()],
      ],

      birthCityId: [obj.birthCityId ? parseInt(obj.birthCityId) : ''],

      birthProvinceId: [
        obj.birthProvinceId ? parseInt(obj.birthProvinceId) : null,
      ],

      emailAddress: [
        obj.emailAddress ? obj.emailAddress : '',
        [Validators.required, Validators.email],
      ],

      emailIsOwn: [
        obj.emailIsOwn ? obj.emailIsOwn : '',
        [Validators.required, RequiredSelectValidator()],
      ],

      mobilePhoneNumber: [
        obj.mobilePhoneNumber ? obj.mobilePhoneNumber.replace('+62', '') : '',
        [
          Validators.required,
          NumericalValidator(),
          MobilePhoneNumberValidator(),
          Validators.maxLength(13),
          Validators.minLength(9),
        ],
      ],

      mediasource: ['ShortApp'],

      pin: [
        obj.pin ? obj.pin : '',
        [
          Validators.required,
          NumericalValidator(),
          Validators.minLength(16),
          Validators.maxLength(16),
        ],
      ],

      bankName: [
        obj.account && obj.account.bankName
          ? obj.account.bankName.toUpperCase()
          : '',
        [RequiredSelectValidator()],
      ],

      bankAccount: [
        obj.account && obj.account.accountNumber
          ? obj.account.accountNumber
          : '',
        [
          Validators.required,
          NumericalValidator(),
          Validators.minLength(5),
          Validators.maxLength(30),
        ],
      ],

      educationType: [
        obj.educationType ? obj.educationType : '0',
        [RequiredSelectValidator()],
      ],

      ktpName: [
        obj.firstName ? `${obj.firstName} ${obj.lastName}` : '',
        [Validators.required, Validators.maxLength(50)],
      ],

      dateOfBirth: [
        obj.dateOfBirth ? obj.dateOfBirth : '',
        [Validators.required],
      ],

      gender: [obj.gender ? obj.gender : '', [RequiredSelectValidator()]],

      domicileAddress_street: [
        obj.domicileAddressObj ? obj.domicileAddressObj.street : '',
        [
          Validators.required,
          Validators.maxLength(90),
          Validators.minLength(2),
        ],
      ],

      /* domicileAddress_buildingType: [
				obj.domicileAddressObj && obj.domicileAddressObj.buildingType
					? obj.domicileAddressObj.buildingType
					: '0',
				[ RequiredSelectValidator() ]
			], */

      domicileAddress_bldNumber: [
        obj.domicileAddressObj && obj.domicileAddressObj.buildingNumber
          ? obj.domicileAddressObj.buildingNumber
          : null,
        [
          Validators.required,
          Validators.maxLength(5),
          AlphaNumericalValidator(),
        ],
      ],

      domicileAddress_buildingType: [
        obj.domicileAddressObj && obj.domicileAddressObj.buildingType
          ? obj.domicileAddressObj.buildingType
          : '0',
        [RequiredSelectValidator()],
      ],

      domicileAddress_flatNumber: [
        obj.domicileAddressObj && obj.domicileAddressObj.flatNumber
          ? obj.domicileAddressObj.flatNumber
          : null,
        [
          Validators.required,
          Validators.maxLength(5),
          AlphaNumericalValidator(),
        ],
      ],

      domicileAddress_rt: [
        obj.domicileAddressObj && obj.domicileAddressObj.rt
          ? obj.domicileAddressObj.rt
          : null,
        [Validators.required, Validators.maxLength(3), NumericalValidator()],
      ],

      domicileAddress_rw: [
        obj.domicileAddressObj && obj.domicileAddressObj.rw
          ? obj.domicileAddressObj.rw
          : null,
        [Validators.required, Validators.maxLength(3), NumericalValidator()],
      ],

      domicileAddress_province: [
        obj.domicileAddressObj && obj.domicileAddressObj.province
          ? obj.domicileAddressObj.province.toUpperCase()
          : '0',
        [RequiredSelectValidator()],
      ],

      // domicileAddress_provinceId: [
      // 	obj.domicileAddressObj &&
      // 	obj.domicileAddressObj.provinceId ? obj.domicileAddressObj.province.toUppercase() : '0'
      // ],

      domicileAddress_city: [
        obj.domicileAddressObj && obj.domicileAddressObj.city
          ? obj.domicileAddressObj.city.toUpperCase()
          : '0',
        [RequiredSelectValidator()],
      ],

      domicileAddress_district: [
        obj.domicileAddressObj && obj.domicileAddressObj.district
          ? obj.domicileAddressObj.district.toUpperCase()
          : '0',
        [RequiredSelectValidator()],
      ],

      domicileAddress_village: [
        obj.domicileAddressObj && obj.domicileAddressObj.village
          ? obj.domicileAddressObj.village.toUpperCase()
          : '0',
        [RequiredSelectValidator()],
      ],

      domicileAddress_postalCode: [
        obj.domicileAddressObj && obj.domicileAddressObj.postalCode
          ? obj.domicileAddressObj.postalCode
          : '0',
        [RequiredSelectValidator()],
      ],

      religion: [
        obj.religion ? obj.religion : '0',
        [RequiredSelectValidator()],
      ],

      citizenship: [
        obj.citizenship ? obj.citizenship : '0',
        [RequiredSelectValidator()],
      ],

      housing_propertyType: [
        obj.housing ? obj.housing.propertyType : '0',
        [RequiredSelectValidator()],
      ],

      housing_residentialType: [
        obj.housing ? obj.housing.residentialType : '0',
        [RequiredSelectValidator()],
      ],

      housing_monthlyCost_show: [
        obj.housing && obj.housing.monthlyResidenceCostShow
          ? obj.housing.monthlyResidenceCostShow
          : numberDelimiter(parseInt(obj.housing.monthlyResidenceCost)),
      ],

      housing_monthlyCost: [
        formGroupDefaultValue(obj.housing.monthlyResidenceCost),
        [Validators.required, NumericalValidator(), Validators.max(1000000000)],
      ],

      housing_expenseCost_show: [
        obj.housing && obj.housing.electricityAndWaterCostShow
          ? obj.housing.electricityAndWaterCostShow
          : numberDelimiter(parseInt(obj.housing.electricityAndWaterCost)),
      ],

      housing_expenseCost: [
        formGroupDefaultValue(obj.housing.electricityAndWaterCost),
        [Validators.required, NumericalValidator(), Validators.max(1000000000)],
      ],

      housing_numberOfPeople: [
        formGroupDefaultValue(obj.housing.numberOfPeople),
        [Validators.required, NumericalValidator(), Validators.max(20)],
      ],

      dependants: [
        obj.dependants === 0 ? 0 : obj.dependants ? obj.dependants : '',
        [Validators.required, NumericalValidator(), Validators.max(15)],
      ],

      mothersName: [
        obj.mothersName ? obj.mothersName : '',
        [Validators.required, Validators.maxLength(30)],
      ],

      contactAddress_province: [
        obj.contactAddress && obj.contactAddress.province
          ? obj.contactAddress.province.toUpperCase()
          : null,
        [RequiredSelectValidator()],
      ],

      contactAddress_city: [
        obj.contactAddress && obj.contactAddress.city
          ? obj.contactAddress.city.toUpperCase()
          : null,
        [RequiredSelectValidator()],
      ],

      contactAddress_district: [
        obj.contactAddress && obj.contactAddress.district
          ? obj.contactAddress.district.toUpperCase()
          : null,
        [RequiredSelectValidator()],
      ],

      contactAddress_village: [
        obj.contactAddress && obj.contactAddress.village
          ? obj.contactAddress.village.toUpperCase()
          : null,
        [RequiredSelectValidator()],
      ],

      contactAddress_postalCode: [
        obj.contactAddress && obj.contactAddress.postalCode
          ? obj.contactAddress.postalCode
          : null,
        [RequiredSelectValidator()],
      ],

      contactAddress_street: [
        obj.contactAddress ? obj.contactAddress.street : '',
        [
          Validators.required,
          Validators.maxLength(90),
          Validators.minLength(2),
          NoSpaceValidator(),
        ],
      ],

      contactAddress_bldNumber: [
        obj.contactAddress && obj.contactAddress.buildingNumber
          ? obj.contactAddress.buildingNumber
          : null,
        [
          Validators.required,
          Validators.maxLength(5),
          AlphaNumericalValidator(),
        ],
      ],

      contactAddress_flatNumber: [
        obj.contactAddress && obj.contactAddress.flatNumber
          ? obj.contactAddress.flatNumber
          : null,
        [
          Validators.required,
          Validators.maxLength(5),
          AlphaNumericalValidator(),
        ],
      ],

      contactAddress_rt: [
        formGroupDefaultValue(obj.contactAddress.rt),
        [NumericalValidator(), Validators.required, Validators.maxLength(3)],
      ],

      contactAddress_rw: [
        formGroupDefaultValue(obj.contactAddress.rw),
        [NumericalValidator(), Validators.required, Validators.maxLength(3)],
      ],

      income_jobType: [
        obj.income ? obj.income.jobType : '0',
        [RequiredSelectValidator()],
      ],

      // income_taxId: ['', [NumericalValidator(), Validators.maxLength(20), Validators.required]],

      // income_employeeId: ['', [NumericalValidator(), Validators.maxLength(20), Validators.required]],

      income_employmentStatus: [
        obj.income ? obj.income.employmentStatus : '0',
        [RequiredSelectValidator()],
      ],

      income_employerName: [
        obj.income ? obj.income.employerName : '',
        [
          Validators.required,
          Validators.maxLength(80),
          NoNumericValidator(),
          NoSpaceValidator(),
        ],
      ],

      income_workPosition: [
        obj.income ? obj.income.workPosition : '0',
        [RequiredSelectValidator()],
      ],

      income_monthlyIncome_show: [
        obj.income && obj.income.monthlyIncomeShow
          ? obj.income.monthlyIncomeShow
          : numberDelimiter(parseInt(obj.income.monthlyIncome)),
      ],

      income_monthlyIncome: [
        obj.income && obj.income.monthlyIncome
          ? parseInt(obj.income.monthlyIncome)
          : null,
        [
          Validators.required,
          NumericalValidator(),
          Validators.min(1000000),
          Validators.max(1000000000),
        ],
      ],

      income_previousIncome_show: [
        obj.income && obj.income.previousIncomeShow
          ? obj.income.previousIncomeShow
          : numberDelimiter(parseInt(obj.income.previousIncome)),
      ],

      income_previousIncome: [
        formGroupDefaultValue(obj.income.previousIncome),
        [Validators.required, NumericalValidator(), Validators.max(1000000000)],
      ],

      // Start of Entrepreneur field
      income_loanPurposeOfWorkingCapital: [
        obj.income && obj.income.loanPurposeOfWorkingCapital
          ? obj.income.loanPurposeOfWorkingCapital
          : '',
      ],

      income_businessName: [
        obj.income && obj.income.businessName ? obj.income.businessName : '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(80),
          NoSpaceValidator(),
          NoDashValidator(),
        ],
      ],
      income_businessType: [
        obj.income && obj.income.businessType ? obj.income.businessType : '0',
        [RequiredSelectValidator()],
      ],
      income_businessAge: [
        obj.income && obj.income.businessAge ? obj.income.businessAge : '0',
        [RequiredSelectValidator()],
      ],

      income_businessIncome_show: [
        obj.income && obj.income.businessIncomeShow
          ? obj.income.businessIncomeShow
          : numberDelimiter(parseInt(obj.income.businessIncome)),
      ],

      income_businessIncome: [
        obj.income && obj.income.businessIncome
          ? parseInt(obj.income.businessIncome)
          : '',
        [
          Validators.required,
          NumericalValidator(),
          Validators.min(1000000),
          Validators.max(1000000000),
        ],
      ],
      income_businessPromotion: [
        obj.income && obj.income.businessPromotion
          ? obj.income.businessPromotion
          : '0',
        [RequiredSelectValidator()],
      ],
      income_onlineChannel: [
        obj.income && obj.income.onlineChannel ? obj.income.onlineChannel : '',
      ],
      income_businessPlace: [
        obj.income && obj.income.businessPlace ? obj.income.businessPlace : '0',
        [RequiredSelectValidator()],
      ],

      income_rentalCosts_show: [
        obj.income && obj.income.rentalCostsShow
          ? obj.income.rentalCostsShow
          : numberDelimiter(obj.income.rentalCosts),
      ],

      income_rentalCosts: [
        obj.income && obj.income.rentalCosts
          ? parseInt(obj.income.rentalCosts)
          : '',
      ],
      income_numberOfEmployees: [
        obj.income && obj.income.numberOfEmployees
          ? obj.income.numberOfEmployees
          : '0',
        [RequiredSelectValidator()],
      ],
      income_helpedByFamilyMembers: [
        obj.income && obj.income.helpedByFamilyMembers
          ? obj.income.helpedByFamilyMembers
          : '',
      ],
      // End of entrepreneur

      maritalStatusType: [
        obj.maritalStatusType ? obj.maritalStatusType : '0',
        [RequiredSelectValidator()],
      ],

      spouse_pin: [
        obj.spouse ? obj.spouse.pin : '',
        [
          NumericalValidator(),
          Validators.minLength(16),
          Validators.maxLength(16),
        ],
      ],

      spouse_name: [
        obj.spouse ? obj.spouse.name : '',
        [Validators.maxLength(50)],
      ],

      spouse_dateOfBirth: [obj.spouse ? obj.spouse.dateOfBirth : ''],

      spouse_splitAssetAgreement: [
        obj.spouse ? obj.spouse.splitAssetAgreement : '',
      ],

      personalReference_name: [
        obj.personalReference && obj.personalReference.name
          ? obj.personalReference.name
          : '',
        [
          Validators.required,
          Validators.maxLength(30),
          NoNumericValidator(),
          NoSpaceValidator(),
        ],
      ],

      personalReference_mobilePhone: [
        obj.personalReference && obj.personalReference.mobilePhone
          ? obj.personalReference.mobilePhone.replace('+62', '')
          : '',
        [
          Validators.required,
          NumericalValidator(),
          MobilePhoneNumberValidator(),
          Validators.maxLength(13),
          Validators.minLength(9),
        ],
      ],

      personalReference_address: [
        obj.personalReference && obj.personalReference.address
          ? obj.personalReference.address
          : '',
        [
          Validators.required,
          Validators.maxLength(100),
          Validators.minLength(2),
          NoSpaceValidator(),
        ],
      ],

      referralCode: [type ? (type === 'topup' ? 'TNKTOPUP' : 'TNK2ND') : ''],
    };

    return group;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TransformObjectFormService_tsickle_Closure_declarations() {
/** @type {?} */
TransformObjectFormService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TransformObjectFormService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
